export default "__VITE_ASSET__7pBX6TI6__"